export type XApiMethods = {
    [key in XAPIS]: {
        [key: string]: XAPI_METHODS_NAMES
    }
};

export const CARD_MODE = 'mode';

export enum CardModes {
    VIEW = 'view',
    ADD = 'add',
    EDIT = 'edit'
};

export enum HTTPS_METHODS {
    GET = 'GET',
    POST = 'POST'
};

export enum XAPIS {
    tenantContracts = 'xapi/proxy/tenant_contracts',
    users = 'xapi/users',
    proxyUsers = 'xapi/proxy/users',
    auth = 'xapi/auth',
    authConnect = 'xapi/auth/connect',
    meters = 'xapi/proxy/meters',
    projects = 'xapi/proxy/projects',
    owners = 'xapi/proxy/owners',
    regions = 'xapi/proxy/regions',
    spaces = 'xapi/proxy/spaces',
    contacts = 'xapi/proxy/contacts',
    organisations = 'xapi/proxy/organisations',
    organisationsCache = 'xapi/organisations',
    tenants = 'xapi/proxy/tenants',
    suppliers = 'xapi/proxy/suppliers',
    people = 'xapi/proxy/people',
    equipments = 'xapi/proxy/equipments',
    interventions = 'xapi/proxy/interventions',
    feedbacks = 'xapi/proxy/feedbacks',
    files = 'xapi/proxy/files',
    agents = 'xapi/proxy/agents',
    buildingReports = 'xapi/proxy/projects',
    permits = 'xapi/proxy/permits',
    invoices = 'xapi/proxy/invoices',
    global = 'xapi/proxy/global',
    meterReadings = 'xapi/proxy/meter-readings',
    leads = 'xapi/proxy/leads',
    // real leads endpoint - proxy/leads is legacy and should no longer be called
    apiLeads = 'xapi/leads',
    rfqs = 'xapi/proxy/rfqs',
    apiRfqs = 'xapi/rfqs',
    apiOffers = 'xapi/offers',
    offers = 'xapi/proxy/offers',
    apiOrders = 'xapi/orders',
    orders = 'xapi/proxy/orders',
    cloffers = 'xapi/proxy/cloffers',
    clorders = 'xapi/proxy/clorders',
    clients = 'xapi/proxy/clients',
    apiClients = 'xapi/clients',
    apiProducts = 'xapi/products',
    apiQualities = 'xapi/qualities',
    apiStock = 'xapi/stock',
    stock = 'xapi/proxy/stock',
    interactions = 'xapi/proxy/interactions',
    // matches the documented /xapi/interactions endpoint (no proxy prefix)
    apiInteractions = 'xapi/interactions',
    products = 'xapi/proxy/products',
    pooling = 'xapi/pooling',
    notifications = 'xapi/notifications'
};

export enum XAPI_METHODS_NAMES {
    setClients = 'set_clients',
    listUsersClients = 'list_clients',
    listProjects = 'list',
    listAgents = 'list',
    listAgentsTypes = 'list_types',
    listTeams = 'list_teams',
    getAgent = 'get_one',
    createAgent = 'create',
    updateAgent = 'update',
    deleteAgent = 'delete',
    list = 'list',
    listUsers = 'list',
    listPermits = 'list_permits',
    listTenantContractStatuses = 'list_statuses',
    listTenantContractActivities = 'list_activities',
    listUsersTypes = 'list_types',
    listTypes = 'list_types',
    listInteractionTypes = 'list_interactions_types',
    listInteractionReasons = 'list_interactions_reasons',
    listPhases = 'list_phases',
    listBuildingReports = 'list_building_reports',
    listBuildingReportTypes = 'list_building_report_types',
    listBuildingReportPhases = 'list_building_report_phases',
    listLeadCategories = 'list_categories',
    listLeadPriorities = 'list_priorities',
    listLeadSizes = 'list_sizes',
    getLead = 'get_one',
    convertLeadToClient = 'convert_to_client',

    listOfferIssued = 'list_offer_issued',
    listInvoices = 'list_invoices',
    listVatRates = 'list_vat_rates',
    listUom = 'list_uoms',
    createInvoice = 'create_invoice',
    deleteInvoice = 'delete_invoice',
    listReadings = 'list_readings',
    createReading = 'create_reading',
    updateReading = 'update_reading',
    deleteReading = 'delete_reading',
    listMeterReadings = 'list_meter_readings',
    listMeters = 'list_meters',
    listMeterTypes = 'list_meter_types',
    listReadingTypes = 'list_reading_types',
    listUtilities = 'list_utilities',
    listSpaces = 'list',
    createMeterReading = 'create_meter_reading',
    updateMeterReading = 'update_meter_reading',
    deleteMeterReading = 'delete_meter_reading',
    // createMeter = 'create_meter',
    // updateMeter = 'update_meter',
    // deleteMeter = 'delete_meter',
    listPermitTypes = 'list_permit_types',
    listPermitStatuses = 'list_permit_statuses',
    createPermit = 'create_permit',
    updatePermit = 'update_permit',
    deletePermit = 'delete_permit',
    listBudgets = 'list_budgets',
    listCurrencies = 'list_currencies',
    listBudgetCategories = 'list_budget_categories',
    deleteBudget = 'delete_budget',
    createBudget = 'create_budget',
    updateBudget = 'update_budget',
    listBusinessPlanReport = 'list_business_plan_report',
    listDevelopmentReport = 'list_pm_report',
    listStatuses = 'list_statuses',
    createUser = 'create',
    createMeter = 'create',
    deleteMeter = 'delete',
    updateMeter = 'update',
    getInfo = 'get_info',
    connect = 'connect',
    pool = 'pool',
    register = 'register',
    create = 'create',
    delete = 'delete',
    checkUsername = 'check_username',
    sendResetEmail = 'send_reset_email',
    changePassword = 'change_password',
    regenerateToken = 'regenerate_token',
    logout = 'logout',
    updatePermissions = 'update_permissions',
    listOwners = 'list',
    listRegions = 'list',
    listContacts = 'list',
    getContact = 'get_one',
    listRoles = 'list_roles',
    createContact = 'create',
    listOrganisations = 'list',
    listTenants = 'list',
    listSuppliers = 'list',
    getSupplier = 'get_one',
    listServices = 'list_services',
    createSupplier = 'create',
    updateSupplier = 'update',
    listPeople = 'list',
    deleteSupplier = 'delete',
    listActivities = 'list_activities',
    listEquipments = 'list',
    createEquipment = 'create',
    updateEquipment = 'update',
    deleteEquipment = 'delete',
    listEquipmentCategories = 'list_categories',
    listEquipmentTypes = 'list_types',
    deleteTenant = 'delete',
    updateTenant = 'update',
    createTenant = 'create',
    listDocumentTypes = 'list_document_types',
    createPerson = 'create',
    listInterventions = 'list',
    createIntervention = 'create',
    updateIntervention = 'update',
    deleteIntervention = 'delete',
    listInterventionTypes = 'list_interaction_types',
    listInterventionReasons = 'list_interaction_reasons',
    listInterventionsCategories = 'list_categories',
    listInterventionStatuses = 'list_statuses',
    listFeedbacks = 'list',
    createFeedback = 'create',
    updateFeedback = 'update',
    deleteFeedback = 'delete',
    feedbackTypes = 'list_types',
    feedbackStatuses = 'list_statuses',
    createOrganisation = 'create',
    deleteOrganisation = 'delete',
    updateOrganisation = 'update',
    updateContact = 'update',
    deleteContact = 'delete',
    listSpacesSubtypes = 'list_subtypes',
    deleteSpace = 'delete',
    updateSpace = 'update',
    createSpace = 'create',
    getOne = 'get_one',
    get = 'get',
    uploadFiles = 'upload',
    deleteFiles = 'delete',
    getFiles = 'get',
    updateProject = 'update',
    update = 'update',
    updateUser = 'update',
    listLeads = 'list',
    createLead = 'create',
    updateLead = 'update',
    deleteLead = 'delete',
    listLeadReasons = 'list_reasons',
    listLeadStatuses = 'list_statuses',
    listLeadLostReasons = 'list_lost_reasons',
    listLeadSources = 'list_sources',
    createOffer = 'create',
    updateOffer = 'update',
    deleteOffer = 'delete',
    getOffer = 'get_one',
    listOfferItems = 'list_items',
    addOfferItem = 'add_item',
    updateOfferItem = 'update_item',
    removeOfferItem = 'remove_item',
    listOfferLostReasons = 'list_lost_reasons',
    createOfferFromRfq = 'create_from_rfq',
    listErpOffers = 'list_erp_offers',
    listErpOfferStatuses = 'list_erp_offer_statuses',
    listErpOfferItems = 'list_erp_offer_items',
    importOffers = 'import_offers',
    placeOrder = 'place_order',
    importOrders = 'import_orders',
    createBuildingReport = 'create_building_report',
    deleteBuildingReport = 'delete_building_report',
    listRequests = 'list',
    listRequestStatuses = 'list_rfqs_statuses',
    getRequest = 'get_one',
    listClientRfqs = 'list_client_rfqs',
    createRfq = 'create',
    updateRfq = 'update',
    deleteRfq = 'delete',
    sendRequest = 'send_request',
    resendMail = 'resend_mail',
    listRfqItems = 'list_items',
    addRfqItem = 'add_item',
    duplicateRfqItem = 'duplicate_item',
    updateRfqItem = 'update_item',
    removeRfqItem = 'remove_item',
    listOffers = 'list_offers',
    listOfferStatuses = 'list_statuses',
    listClientOffers = 'list_client_offers',
    listClientOrders = 'list_client_orders',
    listAgentOffers = 'list_agent_offers',
    listAgentOrders = 'list_agent_orders',
    listProductGroups = 'list_product_groups',
    listProducts = 'list_products',
    listOrders = 'list',
    getOrder = 'get_one',
    createOrder = 'create',
    updateOrder = 'update',
    deleteOrder = 'delete',
    listOrderItems = 'list_items',
    addOrderItem = 'add_item',
    updateOrderItem = 'update_item',
    removeOrderItem = 'remove_item',
    listOrderStatuses = 'list_statuses',
    listErpOrders = 'list_erp_orders',
    listErpOrderStatuses = 'list_erp_order_statuses',
    listErpOrderItems = 'list_erp_order_items',
    listErpOrderReports = 'list_erp_order_reports',
    listClients = 'list',
    getClient = 'get_one',
    getClientPersonalisation = 'get_personalisation',
    createClient = 'create',
    updateClient = 'update',
    deleteClient = 'delete',
    listClientCategories = 'list_categories',
    listClientLostReasons = 'list_lost_reasons',
    listClientPriorities = 'list_priorities',
    listClientSizes = 'list_sizes',
    listClientStatuses = 'list_statuses',
    listStock = 'list_pipes_stock',
    listWarehouses = 'list_warehouses',
    listInteractions = 'list',
    getInteraction = 'get_one',
    listReasons = 'list_reasons',
    createInteraction = 'create',
    updateInteraction = 'update',
    deleteInteraction = 'delete',
    listPipes = 'list_pipes',
    createPipe = 'create_pipe',
    updatePipe = 'update_pipe',
    deletePipe = 'delete_pipe',
    listGroups = 'list_groups',
    listSubgroups = 'list_subgroups',
    listPipesQualities = 'list_pipes_qualities',
    importItems = 'import_items',
    computeDimensions = 'compute_dimensions',
    listErpQualities = 'list_erp',
    computeErpQualities = 'compute_erp_qualities',
    listPipesDimensions = 'list_pipes_dimensions',
    listErpProducts = 'list_erp',
    listErpStock = 'list_erp',
    listErpItems = 'list_erp_items',
    listErpItemGroups = 'list_erp_item_groups',
    listErpMeasureUnits = 'list_erp_measure_units',
    listErpAgents = 'list_erp_agents',
    listErpBusinessPartners = 'list_erp_business_partners',
    listErpPartnersContacts = 'list_erp_partners_contacts',
    createPipeQuality = 'create_pipe_quality',
    updatePipeQuality = 'update_pipe_quality',
    deletePipeQuality = 'delete_pipe_quality',
    createPipeDimension = 'create_pipe_dimension',
    updatePipeDimension = 'update_pipe_dimension',
    deletePipeDimension = 'delete_pipe_dimension',
    read = 'read'
};

export const XAPI_METHODS: XApiMethods = {

    [XAPIS.apiOffers]: {
        [XAPI_METHODS_NAMES.list]: XAPI_METHODS_NAMES.list,
        [XAPI_METHODS_NAMES.getOffer]: XAPI_METHODS_NAMES.getOffer,
        [XAPI_METHODS_NAMES.createOffer]: XAPI_METHODS_NAMES.createOffer,
        [XAPI_METHODS_NAMES.updateOffer]: XAPI_METHODS_NAMES.updateOffer,
        [XAPI_METHODS_NAMES.deleteOffer]: XAPI_METHODS_NAMES.deleteOffer,
        [XAPI_METHODS_NAMES.listOfferStatuses]: XAPI_METHODS_NAMES.listOfferStatuses,
        [XAPI_METHODS_NAMES.listOfferLostReasons]: XAPI_METHODS_NAMES.listOfferLostReasons,
        [XAPI_METHODS_NAMES.createOfferFromRfq]: XAPI_METHODS_NAMES.createOfferFromRfq,
        [XAPI_METHODS_NAMES.listOfferItems]: XAPI_METHODS_NAMES.listOfferItems,
        [XAPI_METHODS_NAMES.addOfferItem]: XAPI_METHODS_NAMES.addOfferItem,
        [XAPI_METHODS_NAMES.updateOfferItem]: XAPI_METHODS_NAMES.updateOfferItem,
        [XAPI_METHODS_NAMES.removeOfferItem]: XAPI_METHODS_NAMES.removeOfferItem,
        [XAPI_METHODS_NAMES.listErpOffers]: XAPI_METHODS_NAMES.listErpOffers,
        [XAPI_METHODS_NAMES.listErpOfferStatuses]: XAPI_METHODS_NAMES.listErpOfferStatuses,
        [XAPI_METHODS_NAMES.listErpOfferItems]: XAPI_METHODS_NAMES.listErpOfferItems,
        [XAPI_METHODS_NAMES.importOffers]: XAPI_METHODS_NAMES.importOffers,
        [XAPI_METHODS_NAMES.placeOrder]: XAPI_METHODS_NAMES.placeOrder,
    },
    [XAPIS.offers]: {
        [XAPI_METHODS_NAMES.list]: XAPI_METHODS_NAMES.list,
        [XAPI_METHODS_NAMES.getOffer]: XAPI_METHODS_NAMES.getOffer,
        [XAPI_METHODS_NAMES.createOffer]: XAPI_METHODS_NAMES.createOffer,
        [XAPI_METHODS_NAMES.updateOffer]: XAPI_METHODS_NAMES.updateOffer,
        [XAPI_METHODS_NAMES.deleteOffer]: XAPI_METHODS_NAMES.deleteOffer,
        [XAPI_METHODS_NAMES.listOfferStatuses]: XAPI_METHODS_NAMES.listOfferStatuses,
        [XAPI_METHODS_NAMES.listOfferLostReasons]: XAPI_METHODS_NAMES.listOfferLostReasons,
        [XAPI_METHODS_NAMES.createOfferFromRfq]: XAPI_METHODS_NAMES.createOfferFromRfq,
        [XAPI_METHODS_NAMES.listOfferItems]: XAPI_METHODS_NAMES.listOfferItems,
        [XAPI_METHODS_NAMES.addOfferItem]: XAPI_METHODS_NAMES.addOfferItem,
        [XAPI_METHODS_NAMES.updateOfferItem]: XAPI_METHODS_NAMES.updateOfferItem,
        [XAPI_METHODS_NAMES.removeOfferItem]: XAPI_METHODS_NAMES.removeOfferItem,
        [XAPI_METHODS_NAMES.listErpOffers]: XAPI_METHODS_NAMES.listErpOffers,
        [XAPI_METHODS_NAMES.listErpOfferStatuses]: XAPI_METHODS_NAMES.listErpOfferStatuses,
        [XAPI_METHODS_NAMES.listErpOfferItems]: XAPI_METHODS_NAMES.listErpOfferItems,
    },
    [XAPIS.orders]: {
        [XAPI_METHODS_NAMES.list]: XAPI_METHODS_NAMES.list,
        [XAPI_METHODS_NAMES.getOrder]: XAPI_METHODS_NAMES.getOrder,
        [XAPI_METHODS_NAMES.createOrder]: XAPI_METHODS_NAMES.createOrder,
        [XAPI_METHODS_NAMES.updateOrder]: XAPI_METHODS_NAMES.updateOrder,
        [XAPI_METHODS_NAMES.deleteOrder]: XAPI_METHODS_NAMES.deleteOrder,
        [XAPI_METHODS_NAMES.listOrderStatuses]: XAPI_METHODS_NAMES.listOrderStatuses,
        [XAPI_METHODS_NAMES.listOrderItems]: XAPI_METHODS_NAMES.listOrderItems,
        [XAPI_METHODS_NAMES.addOrderItem]: XAPI_METHODS_NAMES.addOrderItem,
        [XAPI_METHODS_NAMES.updateOrderItem]: XAPI_METHODS_NAMES.updateOrderItem,
        [XAPI_METHODS_NAMES.removeOrderItem]: XAPI_METHODS_NAMES.removeOrderItem,
        [XAPI_METHODS_NAMES.listErpOrders]: XAPI_METHODS_NAMES.listErpOrders,
        [XAPI_METHODS_NAMES.listErpOrderStatuses]: XAPI_METHODS_NAMES.listErpOrderStatuses,
        [XAPI_METHODS_NAMES.listErpOrderItems]: XAPI_METHODS_NAMES.listErpOrderItems,
        [XAPI_METHODS_NAMES.listErpOrderReports]: XAPI_METHODS_NAMES.listErpOrderReports,
        [XAPI_METHODS_NAMES.importOrders]: XAPI_METHODS_NAMES.importOrders,
    },
    [XAPIS.apiOrders]: {
        [XAPI_METHODS_NAMES.list]: XAPI_METHODS_NAMES.list,
        [XAPI_METHODS_NAMES.getOrder]: XAPI_METHODS_NAMES.getOrder,
        [XAPI_METHODS_NAMES.createOrder]: XAPI_METHODS_NAMES.createOrder,
        [XAPI_METHODS_NAMES.updateOrder]: XAPI_METHODS_NAMES.updateOrder,
        [XAPI_METHODS_NAMES.deleteOrder]: XAPI_METHODS_NAMES.deleteOrder,
        [XAPI_METHODS_NAMES.listOrderStatuses]: XAPI_METHODS_NAMES.listOrderStatuses,
        [XAPI_METHODS_NAMES.listOrderItems]: XAPI_METHODS_NAMES.listOrderItems,
        [XAPI_METHODS_NAMES.addOrderItem]: XAPI_METHODS_NAMES.addOrderItem,
        [XAPI_METHODS_NAMES.updateOrderItem]: XAPI_METHODS_NAMES.updateOrderItem,
        [XAPI_METHODS_NAMES.removeOrderItem]: XAPI_METHODS_NAMES.removeOrderItem,
        [XAPI_METHODS_NAMES.listErpOrders]: XAPI_METHODS_NAMES.listErpOrders,
        [XAPI_METHODS_NAMES.listErpOrderStatuses]: XAPI_METHODS_NAMES.listErpOrderStatuses,
        [XAPI_METHODS_NAMES.listErpOrderItems]: XAPI_METHODS_NAMES.listErpOrderItems,
        [XAPI_METHODS_NAMES.listErpOrderReports]: XAPI_METHODS_NAMES.listErpOrderReports,
        [XAPI_METHODS_NAMES.importOrders]: XAPI_METHODS_NAMES.importOrders,
    },
    [XAPIS.permits]: {
        [XAPI_METHODS_NAMES.list]: XAPI_METHODS_NAMES.list,
        [XAPI_METHODS_NAMES.listPermitTypes]: XAPI_METHODS_NAMES.listPermitTypes,
        [XAPI_METHODS_NAMES.listPermitStatuses]: XAPI_METHODS_NAMES.listPermitStatuses,
        [XAPI_METHODS_NAMES.create]: XAPI_METHODS_NAMES.create,
        [XAPI_METHODS_NAMES.update]: XAPI_METHODS_NAMES.update,
        [XAPI_METHODS_NAMES.createPermit]: XAPI_METHODS_NAMES.createPermit,
        [XAPI_METHODS_NAMES.updatePermit]: XAPI_METHODS_NAMES.updatePermit,
        [XAPI_METHODS_NAMES.delete]: XAPI_METHODS_NAMES.delete
    },
    [XAPIS.agents]: {
        [XAPI_METHODS_NAMES.listAgents]: XAPI_METHODS_NAMES.listAgents,
        [XAPI_METHODS_NAMES.getAgent]: XAPI_METHODS_NAMES.getAgent,
        [XAPI_METHODS_NAMES.listTeams]: XAPI_METHODS_NAMES.listTeams,
        [XAPI_METHODS_NAMES.createAgent]: XAPI_METHODS_NAMES.createAgent,
        [XAPI_METHODS_NAMES.updateAgent]: XAPI_METHODS_NAMES.updateAgent,
        [XAPI_METHODS_NAMES.deleteAgent]: XAPI_METHODS_NAMES.deleteAgent,
        [XAPI_METHODS_NAMES.listErpAgents]: XAPI_METHODS_NAMES.listErpAgents
    },
    [XAPIS.tenantContracts]: {
        [XAPI_METHODS_NAMES.create]: XAPI_METHODS_NAMES.create,
        [XAPI_METHODS_NAMES.list]: XAPI_METHODS_NAMES.list,
        [XAPI_METHODS_NAMES.listActivities]: XAPI_METHODS_NAMES.listActivities,
        [XAPI_METHODS_NAMES.listStatuses]: XAPI_METHODS_NAMES.listStatuses,
        [XAPI_METHODS_NAMES.delete]: XAPI_METHODS_NAMES.delete,
        [XAPI_METHODS_NAMES.update]: XAPI_METHODS_NAMES.update
    },
    [XAPIS.users]: {
        [XAPI_METHODS_NAMES.listUsers]: XAPI_METHODS_NAMES.listUsers,
        [XAPI_METHODS_NAMES.listUsersTypes]: XAPI_METHODS_NAMES.listUsersTypes,
        [XAPI_METHODS_NAMES.createUser]: XAPI_METHODS_NAMES.createUser,
        [XAPI_METHODS_NAMES.delete]: XAPI_METHODS_NAMES.delete,
        [XAPI_METHODS_NAMES.getInfo]: XAPI_METHODS_NAMES.getInfo,
        [XAPI_METHODS_NAMES.updatePermissions]: XAPI_METHODS_NAMES.updatePermissions,
        [XAPI_METHODS_NAMES.updateUser]: XAPI_METHODS_NAMES.updateUser,
        [XAPI_METHODS_NAMES.listRoles]: XAPI_METHODS_NAMES.listRoles,
        [XAPI_METHODS_NAMES.regenerateToken]: XAPI_METHODS_NAMES.regenerateToken,
    },
    [XAPIS.proxyUsers]: {
        [XAPI_METHODS_NAMES.setClients]: XAPI_METHODS_NAMES.setClients,
        [XAPI_METHODS_NAMES.listUsersClients]: XAPI_METHODS_NAMES.listUsersClients,
        [XAPI_METHODS_NAMES.getInfo]: XAPI_METHODS_NAMES.getInfo,
    },
    [XAPIS.auth]: {
        [XAPI_METHODS_NAMES.connect]: XAPI_METHODS_NAMES.connect,
        [XAPI_METHODS_NAMES.register]: XAPI_METHODS_NAMES.register,
        [XAPI_METHODS_NAMES.create]: XAPI_METHODS_NAMES.create,
        [XAPI_METHODS_NAMES.checkUsername]: XAPI_METHODS_NAMES.checkUsername,
        [XAPI_METHODS_NAMES.sendResetEmail]: XAPI_METHODS_NAMES.sendResetEmail,
        [XAPI_METHODS_NAMES.changePassword]: XAPI_METHODS_NAMES.changePassword
    },
    [XAPIS.authConnect]: {
        [XAPI_METHODS_NAMES.connect]: XAPI_METHODS_NAMES.connect
    },
    [XAPIS.meters]: {
        [XAPI_METHODS_NAMES.list]: XAPI_METHODS_NAMES.list,
        [XAPI_METHODS_NAMES.listTypes]: XAPI_METHODS_NAMES.listTypes,
        [XAPI_METHODS_NAMES.listReadingTypes]: XAPI_METHODS_NAMES.listReadingTypes,
        [XAPI_METHODS_NAMES.listUtilities]: XAPI_METHODS_NAMES.listUtilities,
        [XAPI_METHODS_NAMES.createMeter]: XAPI_METHODS_NAMES.createMeter,
        [XAPI_METHODS_NAMES.deleteMeter]: XAPI_METHODS_NAMES.deleteMeter,
        [XAPI_METHODS_NAMES.updateMeter]: XAPI_METHODS_NAMES.updateMeter,
        [XAPI_METHODS_NAMES.listReadings]: XAPI_METHODS_NAMES.listReadings,
        [XAPI_METHODS_NAMES.createReading]: XAPI_METHODS_NAMES.createReading,
        [XAPI_METHODS_NAMES.updateReading]: XAPI_METHODS_NAMES.updateReading,
        [XAPI_METHODS_NAMES.deleteReading]: XAPI_METHODS_NAMES.deleteReading
    },
    [XAPIS.projects]: {
        [XAPI_METHODS_NAMES.listProjects]: XAPI_METHODS_NAMES.listProjects,
        [XAPI_METHODS_NAMES.listTypes]: XAPI_METHODS_NAMES.listTypes,
        [XAPI_METHODS_NAMES.listStatuses]: XAPI_METHODS_NAMES.listStatuses,
        [XAPI_METHODS_NAMES.create]: XAPI_METHODS_NAMES.create,
        [XAPI_METHODS_NAMES.updateProject]: XAPI_METHODS_NAMES.updateProject,
        [XAPI_METHODS_NAMES.delete]: XAPI_METHODS_NAMES.delete,
        [XAPI_METHODS_NAMES.listBuildingReports]: XAPI_METHODS_NAMES.listBuildingReports,
        [XAPI_METHODS_NAMES.listBuildingReportTypes]: XAPI_METHODS_NAMES.listBuildingReportTypes,
        [XAPI_METHODS_NAMES.listBuildingReportPhases]: XAPI_METHODS_NAMES.listBuildingReportPhases,
        [XAPI_METHODS_NAMES.createBuildingReport]: XAPI_METHODS_NAMES.createBuildingReport,
        [XAPI_METHODS_NAMES.deleteBuildingReport]: XAPI_METHODS_NAMES.deleteBuildingReport,
        [XAPI_METHODS_NAMES.listPermits]: XAPI_METHODS_NAMES.listPermits,
        [XAPI_METHODS_NAMES.createPermit]: XAPI_METHODS_NAMES.createPermit,
        [XAPI_METHODS_NAMES.updatePermit]: XAPI_METHODS_NAMES.updatePermit,
        [XAPI_METHODS_NAMES.deletePermit]: XAPI_METHODS_NAMES.deletePermit,
        [XAPI_METHODS_NAMES.listOffers]: XAPI_METHODS_NAMES.listOffers,
        [XAPI_METHODS_NAMES.listOfferIssued]: XAPI_METHODS_NAMES.listOfferIssued,
        [XAPI_METHODS_NAMES.listBudgets]: XAPI_METHODS_NAMES.listBudgets,
        [XAPI_METHODS_NAMES.createBudget]: XAPI_METHODS_NAMES.createBudget,
        [XAPI_METHODS_NAMES.updateBudget]: XAPI_METHODS_NAMES.updateBudget,
        [XAPI_METHODS_NAMES.deleteBudget]: XAPI_METHODS_NAMES.deleteBudget,
        [XAPI_METHODS_NAMES.listBusinessPlanReport]: XAPI_METHODS_NAMES.listBusinessPlanReport,
        [XAPI_METHODS_NAMES.listDevelopmentReport]: XAPI_METHODS_NAMES.listDevelopmentReport,
        [XAPI_METHODS_NAMES.listBudgetCategories]: XAPI_METHODS_NAMES.listBudgetCategories
    },
    [XAPIS.owners]: {
        [XAPI_METHODS_NAMES.listOwners]: XAPI_METHODS_NAMES.listOwners
    },
    [XAPIS.regions]: {
        [XAPI_METHODS_NAMES.listRegions]: XAPI_METHODS_NAMES.listRegions
    },
    [XAPIS.spaces]: {
        [XAPI_METHODS_NAMES.listSpaces]: XAPI_METHODS_NAMES.listSpaces,
        [XAPI_METHODS_NAMES.listStatuses]: XAPI_METHODS_NAMES.listStatuses,
        [XAPI_METHODS_NAMES.listTypes]: XAPI_METHODS_NAMES.listTypes,
        [XAPI_METHODS_NAMES.createSpace]: XAPI_METHODS_NAMES.createSpace,
        [XAPI_METHODS_NAMES.updateSpace]: XAPI_METHODS_NAMES.updateSpace,
        [XAPI_METHODS_NAMES.deleteSpace]: XAPI_METHODS_NAMES.deleteSpace,
        [XAPI_METHODS_NAMES.listSpacesSubtypes]: XAPI_METHODS_NAMES.listSpacesSubtypes
    },
    [XAPIS.contacts]: {
        [XAPI_METHODS_NAMES.listContacts]: XAPI_METHODS_NAMES.listContacts,
        [XAPI_METHODS_NAMES.getContact]: XAPI_METHODS_NAMES.getContact,
        [XAPI_METHODS_NAMES.listRoles]: XAPI_METHODS_NAMES.listRoles,
        [XAPI_METHODS_NAMES.createContact]: XAPI_METHODS_NAMES.createContact,
        [XAPI_METHODS_NAMES.updateContact]: XAPI_METHODS_NAMES.updateContact,
        [XAPI_METHODS_NAMES.deleteContact]: XAPI_METHODS_NAMES.deleteContact
    },
    [XAPIS.organisations]: {
        [XAPI_METHODS_NAMES.listOrganisations]: XAPI_METHODS_NAMES.listOrganisations,
        [XAPI_METHODS_NAMES.createOrganisation]: XAPI_METHODS_NAMES.createOrganisation,
        [XAPI_METHODS_NAMES.deleteOrganisation]: XAPI_METHODS_NAMES.deleteOrganisation,
        [XAPI_METHODS_NAMES.getOne]: XAPI_METHODS_NAMES.getOne,
        [XAPI_METHODS_NAMES.updateOrganisation]: XAPI_METHODS_NAMES.updateOrganisation
    },
    [XAPIS.organisationsCache]: {
        [XAPI_METHODS_NAMES.listOrganisations]: XAPI_METHODS_NAMES.listOrganisations,
        [XAPI_METHODS_NAMES.createOrganisation]: XAPI_METHODS_NAMES.createOrganisation,
        [XAPI_METHODS_NAMES.deleteOrganisation]: XAPI_METHODS_NAMES.deleteOrganisation,
        [XAPI_METHODS_NAMES.getOne]: XAPI_METHODS_NAMES.getOne
    },
    [XAPIS.tenants]: {
        [XAPI_METHODS_NAMES.listTenants]: XAPI_METHODS_NAMES.listTenants,
        [XAPI_METHODS_NAMES.listStatuses]: XAPI_METHODS_NAMES.listStatuses,
        [XAPI_METHODS_NAMES.listTypes]: XAPI_METHODS_NAMES.listTypes,
        [XAPI_METHODS_NAMES.listActivities]: XAPI_METHODS_NAMES.listActivities,
        [XAPI_METHODS_NAMES.deleteTenant]: XAPI_METHODS_NAMES.deleteTenant,
        [XAPI_METHODS_NAMES.updateTenant]: XAPI_METHODS_NAMES.updateTenant,
        [XAPI_METHODS_NAMES.createTenant]: XAPI_METHODS_NAMES.createTenant
    },
    [XAPIS.suppliers]: {
        [XAPI_METHODS_NAMES.listSuppliers]: XAPI_METHODS_NAMES.listSuppliers,
        [XAPI_METHODS_NAMES.getSupplier]: XAPI_METHODS_NAMES.getSupplier,
        [XAPI_METHODS_NAMES.listTypes]: XAPI_METHODS_NAMES.listTypes,
        [XAPI_METHODS_NAMES.listServices]: XAPI_METHODS_NAMES.listServices,
        [XAPI_METHODS_NAMES.listStatuses]: XAPI_METHODS_NAMES.listStatuses,
        [XAPI_METHODS_NAMES.createSupplier]: XAPI_METHODS_NAMES.createSupplier,
        [XAPI_METHODS_NAMES.updateSupplier]: XAPI_METHODS_NAMES.updateSupplier,
        [XAPI_METHODS_NAMES.deleteSupplier]: XAPI_METHODS_NAMES.deleteSupplier,
        [XAPI_METHODS_NAMES.listInvoices]: XAPI_METHODS_NAMES.listInvoices,
        [XAPI_METHODS_NAMES.listVatRates]: XAPI_METHODS_NAMES.listVatRates,
        [XAPI_METHODS_NAMES.listUom]: XAPI_METHODS_NAMES.listUom,
        [XAPI_METHODS_NAMES.createInvoice]: XAPI_METHODS_NAMES.createInvoice,
        [XAPI_METHODS_NAMES.deleteInvoice]: XAPI_METHODS_NAMES.deleteInvoice
    },
    [XAPIS.people]: {
        [XAPI_METHODS_NAMES.listPeople]: XAPI_METHODS_NAMES.listPeople,
        [XAPI_METHODS_NAMES.listDocumentTypes]: XAPI_METHODS_NAMES.listDocumentTypes,
        [XAPI_METHODS_NAMES.createPerson]: XAPI_METHODS_NAMES.createPerson
    },
    [XAPIS.equipments]: {
        [XAPI_METHODS_NAMES.listEquipments]: XAPI_METHODS_NAMES.listEquipments,
        [XAPI_METHODS_NAMES.listEquipmentCategories]: XAPI_METHODS_NAMES.listEquipmentCategories,
        [XAPI_METHODS_NAMES.listEquipmentTypes]: XAPI_METHODS_NAMES.listEquipmentTypes,
        [XAPI_METHODS_NAMES.createEquipment]: XAPI_METHODS_NAMES.createEquipment,
        [XAPI_METHODS_NAMES.updateEquipment]: XAPI_METHODS_NAMES.updateEquipment,
        [XAPI_METHODS_NAMES.deleteEquipment]: XAPI_METHODS_NAMES.deleteEquipment
    },
    [XAPIS.interventions]: {
        [XAPI_METHODS_NAMES.listInterventions]: XAPI_METHODS_NAMES.listInterventions,
        [XAPI_METHODS_NAMES.createIntervention]: XAPI_METHODS_NAMES.createIntervention,
        [XAPI_METHODS_NAMES.updateIntervention]: XAPI_METHODS_NAMES.updateIntervention,
        [XAPI_METHODS_NAMES.deleteIntervention]: XAPI_METHODS_NAMES.deleteIntervention,
        [XAPI_METHODS_NAMES.listInterventionTypes]: XAPI_METHODS_NAMES.listInteractionTypes,
        [XAPI_METHODS_NAMES.listInteractionReasons]: XAPI_METHODS_NAMES.listInteractionReasons,
        [XAPI_METHODS_NAMES.listInterventionsCategories]: XAPI_METHODS_NAMES.listInterventionsCategories,
        [XAPI_METHODS_NAMES.listInterventionStatuses]: XAPI_METHODS_NAMES.listInterventionStatuses
    },
    [XAPIS.feedbacks]: {
        [XAPI_METHODS_NAMES.listFeedbacks]: XAPI_METHODS_NAMES.listFeedbacks,
        [XAPI_METHODS_NAMES.createFeedback]: XAPI_METHODS_NAMES.createFeedback,
        [XAPI_METHODS_NAMES.updateFeedback]: XAPI_METHODS_NAMES.updateFeedback,
        [XAPI_METHODS_NAMES.deleteFeedback]: XAPI_METHODS_NAMES.deleteFeedback,
        [XAPI_METHODS_NAMES.feedbackTypes]: XAPI_METHODS_NAMES.feedbackTypes,
        [XAPI_METHODS_NAMES.feedbackStatuses]: XAPI_METHODS_NAMES.feedbackStatuses
    },
    [XAPIS.files]: {
        [XAPI_METHODS_NAMES.getFiles]: XAPI_METHODS_NAMES.getFiles,
        [XAPI_METHODS_NAMES.uploadFiles]: XAPI_METHODS_NAMES.uploadFiles,
        [XAPI_METHODS_NAMES.deleteFiles]: XAPI_METHODS_NAMES.deleteFiles
    },
    [XAPIS.invoices]: {
        [XAPI_METHODS_NAMES.listInvoices]: XAPI_METHODS_NAMES.listInvoices,
        [XAPI_METHODS_NAMES.listSuppliers]: XAPI_METHODS_NAMES.listSuppliers,
        [XAPI_METHODS_NAMES.listVatRates]: XAPI_METHODS_NAMES.listVatRates,
        [XAPI_METHODS_NAMES.listUom]: XAPI_METHODS_NAMES.listUom,
        [XAPI_METHODS_NAMES.create]: XAPI_METHODS_NAMES.create,
        [XAPI_METHODS_NAMES.delete]: XAPI_METHODS_NAMES.delete,
    },
    [XAPIS.global]: {
        [XAPI_METHODS_NAMES.listCurrencies]: XAPI_METHODS_NAMES.listCurrencies,
    },
    [XAPIS.meterReadings]: {
        [XAPI_METHODS_NAMES.listMeters]: XAPI_METHODS_NAMES.listMeters,
        [XAPI_METHODS_NAMES.listMeterTypes]: XAPI_METHODS_NAMES.listMeterTypes,
        [XAPI_METHODS_NAMES.listReadingTypes]: XAPI_METHODS_NAMES.listReadingTypes,
        [XAPI_METHODS_NAMES.listUtilities]: XAPI_METHODS_NAMES.listUtilities,
        [XAPI_METHODS_NAMES.listSpaces]: XAPI_METHODS_NAMES.listSpaces,
        [XAPI_METHODS_NAMES.createMeter]: XAPI_METHODS_NAMES.createMeter,
        [XAPI_METHODS_NAMES.updateMeter]: XAPI_METHODS_NAMES.updateMeter,
        [XAPI_METHODS_NAMES.deleteMeter]: XAPI_METHODS_NAMES.deleteMeter
    },
    [XAPIS.leads]: {
        [XAPI_METHODS_NAMES.listLeads]: XAPI_METHODS_NAMES.listLeads,
        [XAPI_METHODS_NAMES.getLead]: XAPI_METHODS_NAMES.getLead,
        [XAPI_METHODS_NAMES.createLead]: XAPI_METHODS_NAMES.createLead,
        [XAPI_METHODS_NAMES.updateLead]: XAPI_METHODS_NAMES.updateLead,
        [XAPI_METHODS_NAMES.deleteLead]: XAPI_METHODS_NAMES.deleteLead,
        [XAPI_METHODS_NAMES.convertLeadToClient]: XAPI_METHODS_NAMES.convertLeadToClient,
        [XAPI_METHODS_NAMES.listLeadReasons]: XAPI_METHODS_NAMES.listLeadReasons,
        [XAPI_METHODS_NAMES.listLeadStatuses]: XAPI_METHODS_NAMES.listLeadStatuses,
        [XAPI_METHODS_NAMES.listLeadLostReasons]: XAPI_METHODS_NAMES.listLeadLostReasons,
        [XAPI_METHODS_NAMES.listLeadSources]: XAPI_METHODS_NAMES.listLeadSources,
        [XAPI_METHODS_NAMES.listLeadCategories]: XAPI_METHODS_NAMES.listLeadCategories,
        [XAPI_METHODS_NAMES.listLeadPriorities]: XAPI_METHODS_NAMES.listLeadPriorities,
        [XAPI_METHODS_NAMES.listLeadSizes]: XAPI_METHODS_NAMES.listLeadSizes
    },
    [XAPIS.apiLeads]: {
        [XAPI_METHODS_NAMES.listLeads]: XAPI_METHODS_NAMES.listLeads,
        [XAPI_METHODS_NAMES.getLead]: XAPI_METHODS_NAMES.getLead,
        [XAPI_METHODS_NAMES.createLead]: XAPI_METHODS_NAMES.createLead,
        [XAPI_METHODS_NAMES.updateLead]: XAPI_METHODS_NAMES.updateLead,
        [XAPI_METHODS_NAMES.deleteLead]: XAPI_METHODS_NAMES.deleteLead,
        [XAPI_METHODS_NAMES.convertLeadToClient]: XAPI_METHODS_NAMES.convertLeadToClient,
        [XAPI_METHODS_NAMES.listLeadReasons]: XAPI_METHODS_NAMES.listLeadReasons,
        [XAPI_METHODS_NAMES.listLeadStatuses]: XAPI_METHODS_NAMES.listLeadStatuses,
        [XAPI_METHODS_NAMES.listLeadLostReasons]: XAPI_METHODS_NAMES.listLeadLostReasons,
        [XAPI_METHODS_NAMES.listLeadSources]: XAPI_METHODS_NAMES.listLeadSources,
        [XAPI_METHODS_NAMES.listLeadCategories]: XAPI_METHODS_NAMES.listLeadCategories,
        [XAPI_METHODS_NAMES.listLeadPriorities]: XAPI_METHODS_NAMES.listLeadPriorities,
        [XAPI_METHODS_NAMES.listLeadSizes]: XAPI_METHODS_NAMES.listLeadSizes
    },
    [XAPIS.rfqs]: {
        [XAPI_METHODS_NAMES.list]: XAPI_METHODS_NAMES.list,
        [XAPI_METHODS_NAMES.listRequestStatuses]: XAPI_METHODS_NAMES.listRequestStatuses,
        [XAPI_METHODS_NAMES.getRequest]: XAPI_METHODS_NAMES.getRequest,
        [XAPI_METHODS_NAMES.listClientRfqs]: XAPI_METHODS_NAMES.listClientRfqs,
        [XAPI_METHODS_NAMES.createRfq]: XAPI_METHODS_NAMES.createRfq,
        [XAPI_METHODS_NAMES.updateRfq]: XAPI_METHODS_NAMES.updateRfq,
        [XAPI_METHODS_NAMES.deleteRfq]: XAPI_METHODS_NAMES.deleteRfq,
        [XAPI_METHODS_NAMES.sendRequest]: XAPI_METHODS_NAMES.sendRequest,
        [XAPI_METHODS_NAMES.listRfqItems]: XAPI_METHODS_NAMES.listRfqItems,
        [XAPI_METHODS_NAMES.addRfqItem]: XAPI_METHODS_NAMES.addRfqItem,
        [XAPI_METHODS_NAMES.duplicateRfqItem]: XAPI_METHODS_NAMES.duplicateRfqItem,
        [XAPI_METHODS_NAMES.updateRfqItem]: XAPI_METHODS_NAMES.updateRfqItem,
        [XAPI_METHODS_NAMES.removeRfqItem]: XAPI_METHODS_NAMES.removeRfqItem
    },
    [XAPIS.apiRfqs]: {
        [XAPI_METHODS_NAMES.resendMail]: XAPI_METHODS_NAMES.resendMail
    },
    [XAPIS.apiClients]: {
        [XAPI_METHODS_NAMES.listClients]: XAPI_METHODS_NAMES.listClients
    },
    [XAPIS.apiProducts]: {
        [XAPI_METHODS_NAMES.listPipesQualities]: XAPI_METHODS_NAMES.listPipesQualities,
        [XAPI_METHODS_NAMES.listPipesDimensions]: XAPI_METHODS_NAMES.listPipesDimensions,
        [XAPI_METHODS_NAMES.importItems]: XAPI_METHODS_NAMES.importItems,
        [XAPI_METHODS_NAMES.computeDimensions]: XAPI_METHODS_NAMES.computeDimensions,
        [XAPI_METHODS_NAMES.listErpProducts]: XAPI_METHODS_NAMES.listErpProducts
    },
    [XAPIS.apiQualities]: {
        [XAPI_METHODS_NAMES.listErpQualities]: XAPI_METHODS_NAMES.listErpQualities,
        [XAPI_METHODS_NAMES.computeErpQualities]: XAPI_METHODS_NAMES.computeErpQualities
    },
    [XAPIS.apiStock]: {
        [XAPI_METHODS_NAMES.listErpStock]: XAPI_METHODS_NAMES.listErpStock
    },
    [XAPIS.cloffers]: {
        [XAPI_METHODS_NAMES.listOffers]: XAPI_METHODS_NAMES.listOffers,
        [XAPI_METHODS_NAMES.listOfferStatuses]: XAPI_METHODS_NAMES.listOfferStatuses,
        [XAPI_METHODS_NAMES.listProductGroups]: XAPI_METHODS_NAMES.listProductGroups,
        [XAPI_METHODS_NAMES.listProducts]: XAPI_METHODS_NAMES.listProducts,
        [XAPI_METHODS_NAMES.listClientOffers]: XAPI_METHODS_NAMES.listClientOffers,
        [XAPI_METHODS_NAMES.listAgentOffers]: XAPI_METHODS_NAMES.listAgentOffers,
        [XAPI_METHODS_NAMES.createOffer]: XAPI_METHODS_NAMES.createOffer,
        [XAPI_METHODS_NAMES.updateOffer]: XAPI_METHODS_NAMES.updateOffer,
        [XAPI_METHODS_NAMES.deleteOffer]: XAPI_METHODS_NAMES.deleteOffer,
        [XAPI_METHODS_NAMES.getOffer]: XAPI_METHODS_NAMES.getOffer,
        [XAPI_METHODS_NAMES.listOfferItems]: XAPI_METHODS_NAMES.listOfferItems,
        [XAPI_METHODS_NAMES.addOfferItem]: XAPI_METHODS_NAMES.addOfferItem,
        [XAPI_METHODS_NAMES.updateOfferItem]: XAPI_METHODS_NAMES.updateOfferItem,
        [XAPI_METHODS_NAMES.removeOfferItem]: XAPI_METHODS_NAMES.removeOfferItem,
        [XAPI_METHODS_NAMES.listOfferLostReasons]: XAPI_METHODS_NAMES.listOfferLostReasons,
        [XAPI_METHODS_NAMES.createOfferFromRfq]: XAPI_METHODS_NAMES.createOfferFromRfq
    },
    [XAPIS.clorders]: {
        [XAPI_METHODS_NAMES.listOrders]: XAPI_METHODS_NAMES.listOrders,
        [XAPI_METHODS_NAMES.getOrder]: XAPI_METHODS_NAMES.getOrder,
        [XAPI_METHODS_NAMES.createOrder]: XAPI_METHODS_NAMES.createOrder,
        [XAPI_METHODS_NAMES.updateOrder]: XAPI_METHODS_NAMES.updateOrder,
        [XAPI_METHODS_NAMES.deleteOrder]: XAPI_METHODS_NAMES.deleteOrder,
        [XAPI_METHODS_NAMES.listOrderItems]: XAPI_METHODS_NAMES.listOrderItems,
        [XAPI_METHODS_NAMES.addOrderItem]: XAPI_METHODS_NAMES.addOrderItem,
        [XAPI_METHODS_NAMES.updateOrderItem]: XAPI_METHODS_NAMES.updateOrderItem,
        [XAPI_METHODS_NAMES.removeOrderItem]: XAPI_METHODS_NAMES.removeOrderItem,
        [XAPI_METHODS_NAMES.listOrderStatuses]: XAPI_METHODS_NAMES.listOrderStatuses,
        [XAPI_METHODS_NAMES.listProductGroups]: XAPI_METHODS_NAMES.listProductGroups,
        [XAPI_METHODS_NAMES.listClientOrders]: XAPI_METHODS_NAMES.listClientOrders,
        [XAPI_METHODS_NAMES.listAgentOrders]: XAPI_METHODS_NAMES.listAgentOrders
    },
    [XAPIS.clients]: {
        [XAPI_METHODS_NAMES.listClients]: XAPI_METHODS_NAMES.listClients,
        [XAPI_METHODS_NAMES.getClient]: XAPI_METHODS_NAMES.getClient,
        [XAPI_METHODS_NAMES.getClientPersonalisation]: XAPI_METHODS_NAMES.getClientPersonalisation,
        [XAPI_METHODS_NAMES.createClient]: XAPI_METHODS_NAMES.createClient,
        [XAPI_METHODS_NAMES.updateClient]: XAPI_METHODS_NAMES.updateClient,
        [XAPI_METHODS_NAMES.deleteClient]: XAPI_METHODS_NAMES.deleteClient,
        [XAPI_METHODS_NAMES.listClientCategories]: XAPI_METHODS_NAMES.listClientCategories,
        [XAPI_METHODS_NAMES.listClientLostReasons]: XAPI_METHODS_NAMES.listClientLostReasons,
        [XAPI_METHODS_NAMES.listClientPriorities]: XAPI_METHODS_NAMES.listClientPriorities,
        [XAPI_METHODS_NAMES.listClientSizes]: XAPI_METHODS_NAMES.listClientSizes,
        [XAPI_METHODS_NAMES.listClientStatuses]: XAPI_METHODS_NAMES.listClientStatuses,
        [XAPI_METHODS_NAMES.listErpBusinessPartners]: XAPI_METHODS_NAMES.listErpBusinessPartners,
        [XAPI_METHODS_NAMES.listErpPartnersContacts]: XAPI_METHODS_NAMES.listErpPartnersContacts
    },
    [XAPIS.stock]: {
        [XAPI_METHODS_NAMES.listStock]: XAPI_METHODS_NAMES.listStock,
        [XAPI_METHODS_NAMES.listWarehouses]: XAPI_METHODS_NAMES.listWarehouses
    },
    [XAPIS.interactions]: {
        [XAPI_METHODS_NAMES.listInteractions]: XAPI_METHODS_NAMES.listInteractions,
        [XAPI_METHODS_NAMES.getInteraction]: XAPI_METHODS_NAMES.getInteraction,
        [XAPI_METHODS_NAMES.listInteractionTypes]: XAPI_METHODS_NAMES.listInteractionTypes,
        [XAPI_METHODS_NAMES.listInteractionReasons]: XAPI_METHODS_NAMES.listInteractionReasons,
        [XAPI_METHODS_NAMES.listReasons]: XAPI_METHODS_NAMES.listReasons,
        [XAPI_METHODS_NAMES.createInteraction]: XAPI_METHODS_NAMES.createInteraction,
        [XAPI_METHODS_NAMES.updateInteraction]: XAPI_METHODS_NAMES.updateInteraction,
        [XAPI_METHODS_NAMES.deleteInteraction]: XAPI_METHODS_NAMES.deleteInteraction
    },
    [XAPIS.apiInteractions]: {
        [XAPI_METHODS_NAMES.listInteractions]: XAPI_METHODS_NAMES.listInteractions,
        [XAPI_METHODS_NAMES.getInteraction]: XAPI_METHODS_NAMES.getInteraction,
        [XAPI_METHODS_NAMES.listInteractionTypes]: XAPI_METHODS_NAMES.listInteractionTypes,
        [XAPI_METHODS_NAMES.listInteractionReasons]: XAPI_METHODS_NAMES.listInteractionReasons,
        [XAPI_METHODS_NAMES.createInteraction]: XAPI_METHODS_NAMES.createInteraction,
        [XAPI_METHODS_NAMES.updateInteraction]: XAPI_METHODS_NAMES.updateInteraction,
        [XAPI_METHODS_NAMES.deleteInteraction]: XAPI_METHODS_NAMES.deleteInteraction
    },
    [XAPIS.products]: {
        [XAPI_METHODS_NAMES.listPipes]: XAPI_METHODS_NAMES.listPipes,
        [XAPI_METHODS_NAMES.createPipe]: XAPI_METHODS_NAMES.createPipe,
        [XAPI_METHODS_NAMES.updatePipe]: XAPI_METHODS_NAMES.updatePipe,
        [XAPI_METHODS_NAMES.deletePipe]: XAPI_METHODS_NAMES.deletePipe,
        [XAPI_METHODS_NAMES.listGroups]: XAPI_METHODS_NAMES.listGroups,
        [XAPI_METHODS_NAMES.listSubgroups]: XAPI_METHODS_NAMES.listSubgroups,
        [XAPI_METHODS_NAMES.listPipesQualities]: XAPI_METHODS_NAMES.listPipesQualities,
        [XAPI_METHODS_NAMES.listPipesDimensions]: XAPI_METHODS_NAMES.listPipesDimensions,
        [XAPI_METHODS_NAMES.createPipeQuality]: XAPI_METHODS_NAMES.createPipeQuality,
        [XAPI_METHODS_NAMES.updatePipeQuality]: XAPI_METHODS_NAMES.updatePipeQuality,
        [XAPI_METHODS_NAMES.deletePipeQuality]: XAPI_METHODS_NAMES.deletePipeQuality,
        [XAPI_METHODS_NAMES.createPipeDimension]: XAPI_METHODS_NAMES.createPipeDimension,
        [XAPI_METHODS_NAMES.updatePipeDimension]: XAPI_METHODS_NAMES.updatePipeDimension,
        [XAPI_METHODS_NAMES.deletePipeDimension]: XAPI_METHODS_NAMES.deletePipeDimension,
        [XAPI_METHODS_NAMES.listErpItems]: XAPI_METHODS_NAMES.listErpItems,
        [XAPI_METHODS_NAMES.listErpItemGroups]: XAPI_METHODS_NAMES.listErpItemGroups,
        [XAPI_METHODS_NAMES.listErpMeasureUnits]: XAPI_METHODS_NAMES.listErpMeasureUnits
    },
    [XAPIS.pooling]: {
        [XAPI_METHODS_NAMES.connect]: XAPI_METHODS_NAMES.connect,
        [XAPI_METHODS_NAMES.pool]: XAPI_METHODS_NAMES.pool
    },
    [XAPIS.notifications]: {
        [XAPI_METHODS_NAMES.list]: XAPI_METHODS_NAMES.list,
        [XAPI_METHODS_NAMES.read]: XAPI_METHODS_NAMES.read
    }
};

export interface HttpsRequestBody {
    id: number,
    jsonrpc: string,
    method: XAPI_METHODS_NAMES,
    params?: object
};

export enum ROLES {
    SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
    ADMIN = 'ROLE_ADMIN',
    AGENT = 'ROLE_AGENT',
    CUSTOMER = 'ROLE_CUSTOMER',
    TESTER = 'ROLE_TESTER'
};

export interface UrlProperties {
    fullUrl: string;
    queryString: string;
    queryObject: any;
    pathPieces: Array<string>;
    urlParams: any;
    entirePath: string;
    outletsObject: object;
    outletsString: string;
    hasOutlet: boolean;
}

export interface AuxButtons {
    label: string;
    action: Function;
    show?: boolean;
}
